import { createSlice } from "@reduxjs/toolkit";
import { BuscarContaFinanceiraModel } from "../../../models/contaFinanceira/chamadas/buscarContaFinanceiraModel";
import { CalculoRateioModel } from "../../../models/contaFinanceira/calculoRateioModel";
import { ContaFinanceiraModel } from "../../../models/contaFinanceira/contaFinanceiraModel";
import { HistoricoContaFinanceiraModel } from "../../../models/contaFinanceira/historicoContaFinanceiraModel";
import { RateioModel } from "../../../models/contaFinanceira/rateioModel";
import {
  buscarContaFinanceira,
  buscarContaFinanceiraPorId,
  gerarCalculoRateio,
  listaContaFinanceiraSorteioComSaldo,
  listarHistoricoContaFinanceira,
  listarPlanosContaFinanceiro,
  listarRateioContaFinanceira,
  listarSituacaoContaFinanceira,
  recuperarContaFinanceira,
} from "../../../services/contaFinanceiraService";
import { resetAll } from "../../actions/actions";
import { ListaPlanosModel } from "../../../models/contaFinanceira/listaPlanosModel";
import { ContaFinanceiraComSaldoModel } from "../../../models/contaFinanceira/contaFinanceiraComSaldoModel";
import { UltimoHistoricoFornecedorModel } from "../../../models/contaFinanceira/ultimoHistoricoFornecedorModel";
import dayjs from "dayjs";
import { SelectedRowKeysModel } from "../../../models/sistema/selectedRowKeysModel";

dayjs.locale("pt-br");

export interface ContaFinanceiraState {
  //buscar conta financeira
  loading: boolean;
  busca: BuscarContaFinanceiraModel;
  list: ContaFinanceiraModel[];
  entity: ContaFinanceiraModel;
  //listar rateio conta financeira
  loadingRateio: boolean;
  listRateio: RateioModel[];
  //listar situacao conta financeira
  loadingSituacao: boolean;
  listSituacao: any[];
  //listar historico conta financeira
  loadingHistorico: boolean;
  listHistorico: HistoricoContaFinanceiraModel[];
  //gerar calculo rateio
  loadingCalculo: boolean;
  listCalculo: CalculoRateioModel[];
  //listar planos conta financeira
  loadingPlanos: boolean;
  listPlanos: ListaPlanosModel[];
  //listar contas com saldo
  loadingContasComSaldo: boolean;
  listContasComSaldo: ContaFinanceiraComSaldoModel[];
  //internal
  modalRateio: boolean;
  modalDeletar: boolean;
  modalVoltar: boolean;
  modalHistorico: boolean;
  modalPessoa: boolean;
  page: string;
  selectedRowKeys: SelectedRowKeysModel;
  origemCadastro: "contaFinanceira" | "lancamento" | "guia" | "pendencia";
  tipoCadastro: "despesa" | "receita";
  tipoAcao: "cadastrar" | "editar" | "duplicar";
}

const initialState: ContaFinanceiraState = {
  //buscar conta financeira
  loading: false,
  busca: {
    receitaDespesa: null,
    tipoFiltroData: "VENCI",
    dataInicio: dayjs().startOf("month").toDate(),
    dataFim: dayjs().endOf("month").toDate(),
    idEmpresa: null,
    idUsuario: null,
    geraContabil: null,
    temAnexoComprovante: null,
    statusGuia: null,
    origem: null,
    parcelado: null,
    filtros: null,
  } as BuscarContaFinanceiraModel,
  list: [],
  entity: {} as ContaFinanceiraModel,
  //listar rateio conta financeira
  loadingRateio: false,
  listRateio: [],
  //listar situacao conta financeira
  loadingSituacao: false,
  listSituacao: [],
  //listar historico conta financeira
  loadingHistorico: false,
  listHistorico: [],
  //gerar calculo rateio
  loadingCalculo: false,
  listCalculo: [],
  //listar planos conta financeira
  loadingPlanos: false,
  listPlanos: [],
  //listar contas com saldo
  loadingContasComSaldo: false,
  listContasComSaldo: [],
  //internal
  page: "geral",
  modalRateio: false,
  modalDeletar: false,
  modalVoltar: false,
  modalHistorico: false,
  modalPessoa: false,
  selectedRowKeys: {
    keys: [],
    rows: [],
  } as SelectedRowKeysModel,
  origemCadastro: "contaFinanceira",
  tipoCadastro: "despesa",
  tipoAcao: "cadastrar",
};

export const contaFinanceiraSlice = createSlice({
  name: "contaFinanceira",
  initialState,
  reducers: {
    //buscar conta financeira
    setBuscaContaFinanceira: (state, action) => {
      state.busca = action.payload;
    },
    setEntityContaFinanceira: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setPageContaFinanceira: (state, action) => {
      state.page = action.payload;
    },
    setModalRateioContaFinanceira: (state, action) => {
      state.modalRateio = action.payload;
    },
    setModalDeletarContaFinanceira: (state, action) => {
      state.modalDeletar = action.payload;
    },
    setModalVoltarContaFinanceira: (state, action) => {
      state.modalVoltar = action.payload;
    },
    setModalHistoricoContaFinanceira: (state, action) => {
      state.modalHistorico = action.payload;
    },
    setModalPessoaContaFinanceira: (state, action) => {
      state.modalPessoa = action.payload;
    },
    setSelectedRowKeysContaFinanceira: (state, action) => {
      state.selectedRowKeys = action.payload;
    },
    setOrigemCadastro: (state, action) => {
      state.origemCadastro = action.payload;
    },
    setTipoCadastro: (state, action) => {
      state.tipoCadastro = action.payload;
    },
    setTipoAcao: (state, action) => {
      state.tipoAcao = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar
    builder.addCase(buscarContaFinanceira.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarContaFinanceira.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarContaFinanceira.rejected, (state, action) => {
      state.loading = false;
    });

    //recuperar
    builder.addCase(recuperarContaFinanceira.pending, (state) => {
      // state.loadingBusca = true;
    });
    builder.addCase(recuperarContaFinanceira.fulfilled, (state, action) => {
      state.entity = action.payload;
      // state.loadingBusca = false;
    });
    builder.addCase(recuperarContaFinanceira.rejected, (state, action) => {
      // state.loadingBusca = false;
    });

    //listar rateiro
    builder.addCase(listarRateioContaFinanceira.pending, (state) => {
      state.loadingRateio = true;
    });
    builder.addCase(listarRateioContaFinanceira.fulfilled, (state, action) => {
      state.listRateio = action.payload;
      state.loadingRateio = false;
    });
    builder.addCase(listarRateioContaFinanceira.rejected, (state, action) => {
      state.loadingRateio = false;
    });

    //listar situacao
    builder.addCase(listarSituacaoContaFinanceira.pending, (state) => {
      state.loadingSituacao = true;
    });
    builder.addCase(listarSituacaoContaFinanceira.fulfilled, (state, action) => {
      state.listSituacao = action.payload;
      state.loadingSituacao = false;
    });
    builder.addCase(listarSituacaoContaFinanceira.rejected, (state, action) => {
      state.loadingSituacao = false;
    });

    //listar histórico
    builder.addCase(listarHistoricoContaFinanceira.pending, (state) => {
      state.loadingHistorico = true;
    });
    builder.addCase(listarHistoricoContaFinanceira.fulfilled, (state, action) => {
      state.listHistorico = action.payload;
      state.loadingHistorico = false;
    });
    builder.addCase(listarHistoricoContaFinanceira.rejected, (state, action) => {
      state.loadingHistorico = false;
    });

    //gerar calculo
    builder.addCase(gerarCalculoRateio.pending, (state) => {
      state.loadingCalculo = true;
    });
    builder.addCase(gerarCalculoRateio.fulfilled, (state, action) => {
      state.listCalculo = action.payload;
      state.loadingCalculo = false;
    });
    builder.addCase(gerarCalculoRateio.rejected, (state, action) => {
      state.loadingCalculo = false;
    });

    //listar planos
    builder.addCase(listarPlanosContaFinanceiro.pending, (state) => {
      state.loadingPlanos = true;
    });
    builder.addCase(listarPlanosContaFinanceiro.fulfilled, (state, action) => {
      state.listPlanos = action.payload;
      state.loadingPlanos = false;
    });
    builder.addCase(listarPlanosContaFinanceiro.rejected, (state, action) => {
      state.loadingPlanos = false;
    });

    //listar contas com saldo
    builder.addCase(listaContaFinanceiraSorteioComSaldo.pending, (state) => {
      state.loadingContasComSaldo = true;
    });
    builder.addCase(listaContaFinanceiraSorteioComSaldo.fulfilled, (state, action) => {
      state.listContasComSaldo = action.payload;
      state.loadingContasComSaldo = false;
    });
    builder.addCase(listaContaFinanceiraSorteioComSaldo.rejected, (state, action) => {
      state.loadingContasComSaldo = false;
    });

    //listar por Id
    builder.addCase(buscarContaFinanceiraPorId.pending, (state) => {
      // state.loading = true;
    });
    builder.addCase(buscarContaFinanceiraPorId.fulfilled, (state, action) => {
      state.list = action.payload;
      // state.loading = false;
    });
    builder.addCase(buscarContaFinanceiraPorId.rejected, (state, action) => {
      // state.loading = false;
    });
  },
});

export const {
  //buscar conta financeira
  setBuscaContaFinanceira,
  setEntityContaFinanceira,
  //internal
  setPageContaFinanceira,
  setModalRateioContaFinanceira,
  setModalDeletarContaFinanceira,
  setModalVoltarContaFinanceira,
  setModalHistoricoContaFinanceira,
  setModalPessoaContaFinanceira,
  setSelectedRowKeysContaFinanceira,
  setOrigemCadastro,
  setTipoCadastro,
  setTipoAcao,
} = contaFinanceiraSlice.actions;

export default contaFinanceiraSlice.reducer;
